import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Table, Input, Breadcrumb, Space, Popconfirm, Col, Row, Tooltip } from "antd";
import { debounce } from "lodash";
import { deleteRequest, getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { DeleteFilled } from "@ant-design/icons";

const ArchivedPurchaseRequisition = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [purchaseRequisitionHistory, setPurchaseRequisitionHistory] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  //const [newEmployeeAdded, setNewEmployeeAdded] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getArchivePurchaseRequisition = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(`purchase-requisition-restore/?company_id=${CompanyId}`, state);
        if (apiResponse.data.results.success) {
          setPurchaseRequisitionHistory(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_delete_purchase_requisition_history"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getArchivePurchaseRequisition();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "pr_number" && sortOrder === "ascend") {
      sortingEnumKey = "pr_number";
    }
    if (sortField === "pr_number" && sortOrder === "descend") {
      sortingEnumKey = "-pr_number";
    }
    if (sortField === "pr_created_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_created_date";
    }
    if (sortField === "pr_created_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_created_date";
    }
    if (sortField === "pr_status" && sortOrder === "ascend") {
      sortingEnumKey = "pr_status";
    }
    if (sortField === "pr_status" && sortOrder === "descend") {
      sortingEnumKey = "-pr_status";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "po_order_placed" && sortOrder === "ascend") {
      sortingEnumKey = "po_order_placed";
    }
    if (sortField === "po_order_placed" && sortOrder === "descend") {
      sortingEnumKey = "-po_order_placed";
    }
    if (sortField === "po_delivery_status" && sortOrder === "ascend") {
      sortingEnumKey = "po_delivery_status";
    }
    if (sortField === "po_delivery_status" && sortOrder === "descend") {
      sortingEnumKey = "-po_delivery_status";
    }
    return sortingEnumKey;
  };

  // const handleStatus = async (user_id, status) => { };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  // const rowSelection = {
  //   onChange: (selectedRowKeys) => {
  //     setSelectedRow(selectedRowKeys);
  //   },
  // };

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
          (key) => !changeRows.find((row) => row.id === key)
        );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const columns = [
    {
      title: "PR Number",
      //width: 150,
      dataIndex: "pr_number",
      key: "pr_number",
    },
    {
      title: "PR Created date",
      dataIndex: "pr_created_date",
      key: "pr_created_date",
    },
    {
      title: "PR status",
      dataIndex: "pr_status",
      key: "pr_status",
    //  width: 110,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => {
        if(text.pr_status === "Reject"){
          return (
            <Space>
              <Popconfirm
                className="action"
                title={t("pop_delete_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleDelete(record.id)}
              >
                <DeleteFilled />
              </Popconfirm>
            </Space>
          );
        }else{
          return (
            <Space>
            <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Restore
              </span>
            }
          >
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleRestore(record.id)}
              >
                <ArchiveRestore className="ArchiverestorImg" />
              </Popconfirm>
          </Tooltip>
            </Space>
          );
        }
      },
    },
  ];
  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("purchase-requisition-restore/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          t("purchase_requisition_history_restore_successfully")
        );
        setReload(!reload);
        setSelectedRow([]);
        navigate("/purchase-requisition-history");
      } else {
        ErrorNotificationMsg(
          t("error_in_restore_purchase_requisition_history")
        );
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };


  const handleDelete = async (id) => {
    try {
      setLoading(true);
      let apiResponse = await deleteRequest(`purchase-requisition/${id}/pr-permenent-delete/`)
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          t("purchase_requisition_delete_successfully")
        );
        setLoading(false);
        navigate("/purchase-requisition-history");
      } else {
        setLoading(false);
        ErrorNotificationMsg(
          t("error_in_delete_purchase_requisition_history")
        );
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Archived entries retain historical data and can be reinstated if necessary.
                </span>
              }
            >
            <h3>{t("archived_purchase_requisition")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/purchase-requisition-history">
                Purchase Requisition History
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_archive")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
          </Row>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={purchaseRequisitionHistory}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
             <div className="FormFooter Container">
            {/* <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() =>
                navigate(
                  `/purchase-requisition-history`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            /> */}
             <ButtonField
             className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("pl_back_to_list")}
              onClick={() =>
                navigate(
                  `/purchase-requisition-history`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default ArchivedPurchaseRequisition;
